import { z } from 'zod';
import { FlowTriggerKind } from './kind.js';
export const FLOW_TRIGGER_DEFAULT_QUERY_LIMIT = 100;
export const FLOW_TRIGGER_MAX_QUERY_LIMIT = 500;
export const FlowTriggerFindAllOptionsSchema = z.object({
    kind: z
        .enum(FlowTriggerKind)
        .describe('Return only triggers of this kind, such as an HL7 message or voice call.')
        .optional(),
    organizationId: z
        .union([z.array(z.uuid()), z.uuid()])
        .describe('Return only triggers owned by this organization, or by any of these organizations.')
        .optional(),
    flowId: z.uuid().describe('Return only triggers that start this flow.').optional(),
    limit: z.coerce
        .number()
        .int()
        .positive()
        .max(FLOW_TRIGGER_MAX_QUERY_LIMIT)
        .describe(`Maximum number of triggers to return. Defaults to ${FLOW_TRIGGER_DEFAULT_QUERY_LIMIT.toString()}, capped at ${FLOW_TRIGGER_MAX_QUERY_LIMIT.toString()}.`)
        .optional(),
    offset: z.coerce
        .number()
        .int()
        .nonnegative()
        .describe('Number of matching triggers to skip, for paging. Defaults to 0.')
        .optional(),
    orderBy: z
        .string()
        .describe('Column to order results by. Allowed: id, created, updated. Any other value is ' +
        'ignored and results fall back to id ordering.')
        .optional(),
    orderDirection: z
        .enum(['asc', 'desc'])
        .describe('Direction to order results: ascending or descending.')
        .optional(),
});
//# sourceMappingURL=findAllOptions.js.map